import { ReactNode } from "react";
import { Title } from "react-head";


interface IPageProps {
  title?: ReactNode,
  browserTitle?: string,
  children?: ReactNode
}

export default function Page(
  {
    title,
    browserTitle,
    children
  }: IPageProps
) {
  const titleInBrowser = browserTitle ?? (typeof title === "string" ? title : undefined);

  return (
    <div className="px-2 md:px-8 dark:md:px-6">
      <Title>ScraperAPI{ titleInBrowser && (" | " + titleInBrowser) }</Title>
      <div className="text-2xl py-6">
        { title }
      </div>
      { children }
    </div>
  );
};
